import { virtualDir } from "./skyward.base.global";
import { registerEvents } from "./skyward.ui.events";
import { loadContent } from "./skyward.ui.window";
import { JQueryInput } from "./types";

const skyward = window.skyward;

const classes =
{
    existsAsFavorite: "existsAsFavorite"
};

const dataAttributes =
{
    favoriteId: "favorite-id"
};

registerEvents("favorites",
    {
        openMenu,
        addOrRemoveFavorite,
        edit
    }
);

function openMenu(this: JQueryInput)
{
    const clickedElement = $(this);

    return buildPopup()
        .done(function (data)
        {
            const content = data.content.Content;
            const footer = data.footer.Content;
            const dialog = skyward.modalLayer.showInformationBubble("Favorites", content, null, { anchorTo: clickedElement, useSmallWidth: true });
            dialog.container.append(footer);
        });
}

function edit(this: JQueryInput)
{
    return loadContent("full", "SkySys", "UserFavorite", "List", null);
}

function addOrRemoveFavorite(this: JQueryInput)
{
    const favoriteSelector = $(this);
    if (favoriteSelector.hasClass(classes.existsAsFavorite))
    {
        const id = favoriteSelector.data(dataAttributes.favoriteId);

        return deleteThisFavorite(id!)
            .done(function ()
            {
                toggleFavoritesSelectorAction(favoriteSelector, false, id!, window.location.href);
            });
    }

    return addFavorite()
        .done(function (data)
        {
            if (!data.alreadyExists)
            {
                toggleFavoritesSelectorAction(favoriteSelector, true, data.id, window.location.href);
            }
        });
}

function addFavorite()
{
    return $.ajax({
        url: `${virtualDir}SkySys/UserFavorite/AddFavorite`,
        type: "POST",
        dataType: "JSON",
        data: { ScreenFriendlyName: $("#friendlyNameContents").text() }
    });
}

function deleteThisFavorite(id: string)
{
    return $.ajax({
        url: `${virtualDir}SkySys/UserFavorite/DeleteFavorite`,
        type: "POST",
        dataType: "JSON",
        data: { id }
    });
}

function buildPopup()
{
    return $.ajax({
        url: `${virtualDir}SkySys/UserFavorite/PopulateFavorites/`,
        type: "POST",
        dataType: "JSON"
    });
}

function toggleFavoritesSelectorAction(favoriteSelector: JQuery<HTMLElement>, canAddFavorite: boolean, id: string, location: string)
{
    if (canAddFavorite)
    {
        favoriteSelector.addClass(classes.existsAsFavorite);
        favoriteSelector.data(dataAttributes.favoriteId, id);
        favoriteSelector.attr("aria-label", "Remove Favorite");
    }
    else
    {
        favoriteSelector.removeClass(classes.existsAsFavorite);
        favoriteSelector.removeData(dataAttributes.favoriteId);
        favoriteSelector.attr("aria-label", "Add Favorite");
    }

    if (location.includes("SkySys/UserFavorite/List"))
    {
        skyward.browse.get('browse');
    }
}